import { useMemo } from 'react';

import { useMediaQuery } from '@bonusly/design-system';

import { theme } from '../../lib/theme/theme';
import { BreakpointList, Breakpoints, ScreenSizeDeterminers } from './types';

const orderBreakpoints = (breakpoints: Breakpoints): BreakpointList =>
	Object.entries<string>(breakpoints).sort(([, a], [, b]) => parseInt(a, 10) - parseInt(b, 10));

const capitalize = (string: string) => string[0].toUpperCase() + string.substring(1);

const createQueries = (breakpoints: BreakpointList): string[] => breakpoints.map(([, size]) => `(min-width: ${size})`);

const createDeterminers = (sizes: BreakpointList, queries: boolean[]): ScreenSizeDeterminers =>
	sizes.reduce(
		(acc, [size], index) => ({
			...acc,
			[`is${capitalize(size)}`]: queries[index] && !queries.slice(index + 1).some(Boolean),
			[`isAtLeast${capitalize(size)}`]: queries[index],
		}),
		{} as ScreenSizeDeterminers
	);

const breakpoints = orderBreakpoints(theme.breakpoints);
const mediaQueries = createQueries(breakpoints);

export const useScreenSize = (): ScreenSizeDeterminers => {
	const queries = useMediaQuery(mediaQueries);

	return useMemo(() => createDeterminers(breakpoints, queries), [queries]);
};
